import {
    LOAD_AUTHORIZED_APPS,
    ADD_AUTHORIZED_APP,
    UPDATE_AUTHORIZED_APP,
    DELETE_AUTHORIZED_APP,
} from './authorizedAppsConstants';

export default function (state, { type, payload }) {
    switch (type) {
        case LOAD_AUTHORIZED_APPS: return { authorizedApps: payload };
        case ADD_AUTHORIZED_APP: return { authorizedApps: [...state.authorizedApps, payload] };
        case UPDATE_AUTHORIZED_APP: {
            const authorizedAppToUpdate = state.authorizedApps.find((authorizedApp) => authorizedApp.id === payload.id);
            return { authorizedApps: [
                ...state.authorizedApps.filter((authorizedApp) => authorizedApp.id !== payload.id),
                Object.assign({}, authorizedAppToUpdate, { payload }),
            ] };
        }
        case DELETE_AUTHORIZED_APP: return { authorizedApps: state.authorizedApps.filter((authorizedApp) => authorizedApp.id !== payload) };
        default: return state;
    }
}


export function authorizedAppsHasErrored(state = false, action) {
    switch (action.type) {
        case 'AUTHORIZED_APPS_HAS_ERRORED':
            return action.hasErrored;
        default:
            return state;
    }
}
export function authorizedAppsIsLoading(state = false, action) {
    switch (action.type) {
        case 'AUTHORIZED_APPS_IS_LOADING':
            return action.isLoading;
        default:
            return state;
    }
}
export function authorizedApps(state = [], action) {
    switch (action.type) {
        case 'AUTHORIZED_APPS_FETCH_DATA_SUCCESS':
            return action.authorizedApps;
        default:
            return state;
    }
}
